//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {}
  },
  computed: {
    menu() {
      return [
        { path: '/', name: this.$t('Home'), icon: 'home' },
        { path: '/search', name: this.$t('Search'), icon: 'search' },
        { path: '/account/bets', name: this.$t('My Bets'), icon: 'history', count: 0 },
        { path: 'live', name: this.$t('In-Play'), icon: 'tachometer-alt', count: 0 },
        { path: '/esports', name: this.$t('E-Gaming'), icon: 'gamepad', count: 0 },
        { path: '/virtual', name: this.$t('Virtual Sports'), icon: 'gamepad', count: 0 },
        { path: '/horse-racing', name: this.$t('Horse Racing'), icon: 'horse', count: 0 },
        { path: '/greyhounds', name: this.$t('Greyhounds'), icon: 'dog', count: 0 },
        { path: '/promotions', name: this.$t('Promotions'), icon: 'gift', count: 0 },
      ]
    },
    popularPages() {
      return _.filter(_.get(this.general, 'popular_pages'), page => { 
        let isValid = true;

        if(page.starts_at && this.$date(page.starts_at).isAfter()) {
          isValid = false
        }
        if(page.ends_at && this.$date(page.ends_at).isBefore()) {
            isValid = false
        } 
        return isValid
      })
    }
  },
  mounted() {},
  methods: {

    openGlobalIframe(url = '/help') {
      this.loadGlobalIframe('open_page', {'url': url})
    },
  }
}
